/* eslint-disable */
import axios from 'axios'
import {
  Loading,
  Message
} from 'element-ui'
import router from '@/router'
import store from '@/store/index'
import { throwErr } from './throwErr.js'
let api = axios.create({
  headers: {
    load: true
  }
});

let loading

function startLoading() {
  loading = Loading.service({
    lock: true,
    spinner: 'tt-loading',
    text: '',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading() {
  loading && loading.close()
}
api.defaults.baseURL = process.env.ROOT_URL
// api.defaults.timeout = 5000
api.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
api.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
const CancelToken = axios.CancelToken;
// 请求拦截
api.interceptors.request.use(function (config) {
  config.cancelToken = new CancelToken(cancel => {
    store.state.login["_axiosPromiseCancel"].push(cancel);
  });
  if (config.headers.load) {
    startLoading()
  }
  // 在发送请求之前做些什么
  if (store.state.user.token) {
    config.headers.Authorization = store.state.user.token
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  Message.error('网络错误,请稍后再试')
  return Promise.reject(error)
});
// 添加响应拦截器
api.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  endLoading()
  const status = response.data.code
  if (status === '200') {
    return response;
  } else if (status === '500') {
    response.data.message && Message.error(response.data.message)
    response.data.data = []
    return response
  } else if (status === '401' || status === '600') {
    response.data.data = []
    localStorage.removeItem('vuex')
    //跳转到登录页面
    Message.error(response.data.message)
    router.push('/login')
  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  endLoading()
  if (error && error.response) {
    // 获取状态码
    let res = {}
    res.code = error.response.status
    res.message = throwErr(error.response.status, error.response)
    res.data = {
      data: []
    }
    Message.error({
      message: res.message
    })
    return Promise.resolve(res) // 返回接口返回的错误信息
  }
})
export default api



// WEBPACK FOOTER //
// ./src/axios/http.js